"use strict";

import BaseModel from "dias/core/models/baseModel";

class Textbaustein extends BaseModel {
  constructor() {
    super("textbausteine");
  }
}

export default Textbaustein;
